import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Page, Tabs } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { analytics } from 'app/utils/segment';
import { TemplatesTab } from './components/templatesTab';
var TemplateTabs;
(function (TemplateTabs) {
    TemplateTabs["QuickResponseTab"] = "Quick response";
    TemplateTabs["AutoReplyTab"] = "Auto reply";
})(TemplateTabs || (TemplateTabs = {}));
const tabsDefinition = Object.values(TemplateTabs).map((tabName) => ({
    id: tabName,
    label: tabName,
}));
export const TEMPLATE_NAMES = {
    quick_response: 'Quick response',
    email_auto_reply: 'Auto reply',
    email_signature: 'Email signature',
};
export const Templates = (props) => {
    const [activeTab, setActiveTab] = useState(TemplateTabs.QuickResponseTab);
    const handleTabChange = (tab) => {
        var _a, _b;
        setActiveTab(tab);
        analytics.settingsTemplatesTabClicked({
            tab: (_b = (_a = Object.entries(TEMPLATE_NAMES).find(([_, name]) => name === tab)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : '',
        });
    };
    const { templates, notificationAdd, hasLanguageTranslationControlFF } = props;
    return (_jsxs(_Fragment, { children: [_jsx(Page.Tabs, { children: _jsx(Tabs, { selectedId: activeTab, tabs: tabsDefinition, onChange: handleTabChange }) }), _jsxs(Page.Body, { children: [activeTab === TemplateTabs.QuickResponseTab && (_jsx(TemplatesTab, { templateType: "quick_response", sectionTitle: "All quick response templates", templates: templates, notificationAdd: notificationAdd, hasLanguageTranslationControlFF: hasLanguageTranslationControlFF })), activeTab === TemplateTabs.AutoReplyTab && (_jsx(TemplatesTab, { templateType: "email_auto_reply", sectionTitle: "All auto reply templates", templates: templates, notificationAdd: notificationAdd, hasLanguageTranslationControlFF: hasLanguageTranslationControlFF }))] })] }));
};
